import { useEffect, useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthProvider/useAuth';
import { getHeaderItems } from '../../services/header';
import { IHeaderItems } from './types';
import {
  LockOutlined,
  LoginOutlined,
  MenuOutlined
} from '@ant-design/icons';
import Button from '../UI/Button';
import { Dropdown, message } from 'antd';
import MobileHeaderMenu from '../MobileHeaderMenu';
import HeaderLogo from './HeaderLogo';
import HeaderNavBar from './HeaderNavBar';

function Header() {

  const [menuItems, setMenuItems] = useState<IHeaderItems[]>([])
  const { pathname } = useLocation()
  const auth = useAuth()
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if(pathname === '/') return setMenuItems([])
      if(menuItems.length > 0) return 
      const res = await getHeaderItems()
      if (res) setMenuItems(res as IHeaderItems[])
    })()
  }, [pathname])

  const logoutAndRedirect = async () => {
    await auth.logout()
    navigate('/logoff')
  }

  return (
    <>
      {pathname !== '/' && (
        <div className="header">
          <div className="header__container">
            <HeaderLogo />
            <HeaderNavBar items={menuItems}/>
            <MobileHeaderMenu  items={menuItems} logOut={logoutAndRedirect}/>
            <div className="header__logout mobile-hidden" id='LogOut' onClick={() => logoutAndRedirect()}><LoginOutlined style={{fontSize: 18}}/></div>
          </div>
        </div>
      )}
    </>
  )
}

export default Header